module.exports = __webpack_public_path__ + "img/icon-question.80818619.svg";